import { useState } from "react";
import {
  deleteNotficationSubscriptionForIds,
  postNotificationSubscriptionForIds,
} from "src/requests/notifications/requests";
import { useFetchAllNotifications } from "src/store/notifications/useActions";
import flowioast from "src/utils/flowioast";

export const useSubmitNotificationSubscriptions = (
  onSuccessCallback: () => void
) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const refetchNotifications = useFetchAllNotifications();

  const submitSubscriptions = async (
    idsToSubscribe: number[],
    idsToUnsubscribe: number[]
  ) => {
    if (!idsToSubscribe.length && !idsToUnsubscribe.length) return;

    setIsSubmitting(true);

    try {
      if (idsToSubscribe.length) {
        await postNotificationSubscriptionForIds(idsToSubscribe);
      }
      if (idsToUnsubscribe.length) {
        await deleteNotficationSubscriptionForIds(idsToUnsubscribe);
      }

      refetchNotifications();
      onSuccessCallback();
    } catch (error) {
      flowioast.error.fromIntlBase("settings.save.singular", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, submitSubscriptions };
};
